module.exports = __webpack_public_path__ + "media/images/people/girl-11-75446c13a5bb038dcf4a5bb1f6e12ba7.webp";